// TODO: From App New
<template>
  <b-card>
    <FormBuilder
      label="Sale"
      create
      :fields="fields"
      :loading-submit="$store.state.saleV2.loadingSubmit"
      @submit="submitData"
    />
  </b-card>
</template>

<script>
import FormBuilder from '@/layouts/components/v2/FormBuilder.vue'

import {
  BCard,
} from 'bootstrap-vue'

import fields from '@/field/form/sale'

export default {
  components: {
    BCard,
    FormBuilder,
  },
  setup() {
    return {
      fields,
    }
  },
  computed: {
    userData() {
      return this.$store.state.auth.userData
    },
  },
  methods: {
    submitData(data, callback) {
      // Add owner_merchant_id based on user role
      const enrichedData = this.addOwnerMerchantId(data)

      this.$store.dispatch('saleV2/create', enrichedData)
        .then(() => {
          if (typeof callback === 'function') callback()
        })
        .catch(err => callback(err))
    },
    addOwnerMerchantId(data) {
      const { userData } = this

      if (!userData) {
        return data
      }

      // If merchant, use their merchant ID
      if (userData.role === 'merchant' && userData.merchant?.id) {
        return {
          ...data,
          owner_merchant_id: userData.merchant.id,
        }
      }

      // If admin, use Miniapoly official store ID (you can set this as constant)
      // if (userData.role === 'admin') {
      //   // TODO: Replace with actual Miniapoly official store merchant ID
      //   const MINIAPOLY_OFFICIAL_MERCHANT_ID = '94a9099584e54a43894ddeac77b9e3e6'
      //   console.log('Setting admin owner_merchant_id to:', MINIAPOLY_OFFICIAL_MERCHANT_ID)
      //   return {
      //     ...data,
      //     owner_merchant_id: MINIAPOLY_OFFICIAL_MERCHANT_ID,
      //   }
      // }

      return data
    },
  },
}
</script>

<style scoped>

</style>
